import React from 'react'
import "../../index.css"

export default function SuccessAlert({children}) {
  return (
    <div className="success_alert">{children}</div>
  )
}
